module.exports = __webpack_public_path__ + "static/media/playerIcon.62ddbbd0.png";